<template>
  <div>
    <Console
      v-if="sessionId"
      :sessionId="sessionId" />

    <Chart
      class="chart"
      v-if="events.length"
      :events="events" />

    <div
      v-if="sessionId"
      class="links">
        #{{sessionId}} /
        <a
          :href="`https://${serverOrigin}/video/${sessionId}/`"
          target="_blank">
            archive
        </a>
        /
        <a
          :href="`https://${serverOrigin}/admin/proctoring/session/${sessionId}/`"
          target="_blank">
            admin page
        </a>
    </div>

    <div class="grouppedEvents">
      <div
        v-for="(group, i) in grouppedEvents"
        :key="i"
        class="group">

          <Event
            :serverOrigin="serverOrigin"
            :session="eventSession(group[0])"
            :user="eventUser(group[0])"
            :icon="eventIcon(group[0])"
            :timestamp="eventTimestamp(group[0])"
            :event="group[0]"/>

          <details
            class="eventsGroup"
            v-if="group.length > 1">

              <summary class="eventsGroupLabel">
                + {{ group.length - 1 }} similar events
              </summary>

              <div class="eventsGroupContent">
                <Event
                  v-for="event in group.slice(1)"
                  :serverOrigin="serverOrigin"
                  :session="eventSession(event)"
                  :user="eventUser(event)"
                  :icon="eventIcon(event)"
                  :key="event._id"
                  :timestamp="eventTimestamp(event)"
                  :event="event"/>
              </div>

          </details>

      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

import {partitionBy} from '@/utils'

import Event from '@/components/Event'
import Chart from '@/components/Chart'
import Console from '@/components/Console'

export default {
  name: 'Events',
  props: {
    serverOrigin: String,
    sessionId: String,
    userEmail: String
  },
  data () {
    return { /* Initial state from props. */
      searchParams: {
        serverOrigin: this.serverOrigin,
        userEmail: this.userEmail,
        sessionId: this.sessionId}}
  },
  components: {
    Event,
    Chart,
    Console
  },
  created () {
    this.updateEvents()
  },
  methods: {
    updateEvents () {
      if (this.gotFilter) this.loadFiltered(this.searchParams)
    },
    eventSession (event) {
      return event.context
        ? event.context.session
        : {id: ''}
    },
    eventUser (event) {
      return event.context
        ? event.context.user
        : {id: ''}
    },
    eventTimestamp (event) {
      let time = new Date(event.created)
      return time.toLocaleString()
    },
    eventIcon (event) {
      let content = {
        'syscheck_result': _ =>
          event.data[0] === 'success'
            ? 'ok'
            : 'fail'
      }[event.eventType]

      return content
        ? {
          'ok': '✓',
          'fail': '✗'
        }[content()]
        : ''
    },
    ...mapActions([
      'loadFiltered',
      'loadMore'
    ])
  },
  watch: {
    '$route' (to, _from) {
      /* Update state. */
      this.searchParams = to.params
      this.updateEvents()
    }
  },
  computed: {
    gotFilter () {
      let {userEmail, sessionId} = this.searchParams
      return [userEmail, sessionId].some(Boolean)
    },
    grouppedEvents () {
      return partitionBy(
        x => x.eventType)(this.events)
    },
    events () {
      return this.filteredEvents(this.searchParams)
    },
    ...mapGetters([
      'filteredEvents'
    ])
  }
}
</script>

<style scoped>
.chart {
  margin-bottom: 20px;
}

.links {
  margin-bottom: 30px;
}

.links a {
  color: inherit;
}

.eventsGroup {
  color: #757575;
  border-left: 2px solid #BDBDBD;
  margin-left: 15px;
  margin-bottom: 20px;
  margin-top: -10px;
}

.eventsGroupLabel {
  padding: 15px;
  cursor: pointer;
}

.eventsGroupContent {
  margin-left: -5px;
}

details summary::-webkit-details-marker {
  display:none;
}

</style>
